import React from "react";
import { useAsync } from "react-async";

import { getAllHiredPlacements } from "services";
// import {Spinner}
import { HiredPlacementCard } from "./HiredPlacementCard";

export function HiredPlacementList(): JSX.Element {
  const { data } = useAsync({ promiseFn: getAllHiredPlacements });

  return (
    <>
      {data &&
        data
          .filter(hiredPlacement => hiredPlacement.display === true)
          .map(hiredPlacement => (
            <HiredPlacementCard key={hiredPlacement.id} hiredPlacement={hiredPlacement} />
          ))}
    </>
  );
}
